<template>
    <vs-col :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}" vs-lg="2" vs-xs="12" class="p-1" id="WaitingServiceChart">
        <vs-card style="height: 115px" :id="title" class="vs-con-loading__container">
            <div style="height: 10px;width: 100%" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" slot="header">
              <h5 style="font-size: 13px">
              {{title}}
              </h5>
            </div>

          <div style="display: flex;justify-content: center;height: 20px">
            <div v-if="data != null" class="col" style="font-size: 18px;font-weight: bold;display: flex">
              <i v-if="icon && data != -1" :style="{'transform': $i18n.locale === 'ar' ? 'scaleX(-1)' : ''}" :class="'mdi '+ icon +' h3 text-primary'"  style="margin-left: 5px;margin-right: 5px"></i><div style="display: flex">{{ data != -1 ? Math.round(data) : '--'}} <div v-if="isMinutes && data != -1" style="font-weight: normal;font-size: 16px;margin-right: 4px;margin-left: 4px">({{$t('Statistics.minutes')}})</div></div>
            </div>
          <div class="spinner-border text-primary" role="status" v-else>
            <span class="sr-only">Loading...</span>
          </div>
          </div>
        </vs-card>
    </vs-col>
</template>

<script>
import 'vue2-datepicker/index.css';

export default {
    name:"SmallStatBox",
    data:() => ({

    }),
    props : {
      title : {required: true, type: String},
      data : {required: true, type: Number},
      isMinutes : {required: true, type: Boolean},
      icon : {required: false, type: String}
    },
    components:{

    },
    methods:{
    },
    mounted() {

    }
}
</script>

<style>

  
</style>